// extracted by mini-css-extract-plugin
export default {"tabs":"dETGWX5ataIfw7FFvwKI","tabItems":"_u0cbz93Nt_PuG36wkU3"};